import { render } from "./EndingAccountsTable.vue?vue&type=template&id=3a655f72"
import script from "./EndingAccountsTable.vue?vue&type=script&lang=js"
export * from "./EndingAccountsTable.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\ssradius\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__